/* @jsx m */
import m from 'mithril';
import DeviceWrapper from '../components/DeviceWrapper.jsx';
import AppHeader from '../components/AppHeader.jsx';
import StatusBar from '../components/StatusBar.jsx';

export default function menu() {
  return {
    view: () => {
      return (
      <DeviceWrapper>
        <StatusBar />
        <AppHeader />
        <div class="center-align" id="menu">
              <ul class="menu">
                <span class="notify"></span>
                <h2>Menu</h2>
                <li class="menu-item">
                  <a class="btn btn-link" href="#/play">
                    Resume
                  </a>
                </li>
                {/* <li class="menu-item d-none">
                  <button class="btn btn-link saveBtn">Save</button>
                </li> */}
                {/* <li class="menu-item">
                  <a class="btn btn-link prefsBtn" href="#/menu/preferences/">Prefs</a>
                </li> */}
                {/* <li class="menu-item d-none">
                  <a class="btn btn-link etcBtn" href="#/menu/etc/">Etc</a>
                </li> */}
              </ul>
            </div>
      </DeviceWrapper>
      );
    }
  }
}